import { useEffect, useRef, useState } from "react";
import {
    FaBell,
    FaCalendarAlt,
    FaCheckCircle,
    FaEdit,
    FaFileCsv,
    FaHome,
    FaPlus,
    FaSignOutAlt,
    FaThLarge,
    FaTrash
} from "react-icons/fa";

import { Link } from "react-router-dom";
import "./css/AdminManageVillas.css";

function AdminManageVillas() {

const [villas, setVillas] = useState([]);
const [showModal, setShowModal] = useState(false);
const [editIndex, setEditIndex] = useState(null);

// Reference input file terpisah untuk Mitra dan Room
const fileInputRef = useRef(null);
const roomFileInputRef = useRef(null); 

const [form, setForm] = useState({
    id: "",
    name: "",
    location: "",
    mitra_name: "-",
    link_wa: "-",
    price: "",
    rating: "5",
    guests: "4",
    beds: "2",
    baths: "1",
    bed_type: "1 King Size",
    check_in_time: "14:00",
    check_out_time: "12:00",
    status: "available"
});

// FETCH DATA MITRA UTAMA
const fetchVillas = () => {
    fetch("http://localhost:5000/api/admin/villas")
        .then((res) => {
            if (!res.ok) {
                throw new Error("Gagal mengambil data dari server");
            }
            return res.json();
        })
        .then((resData) => {
            if (resData.status === "success" || resData.data) {
                setVillas(resData.data || resData);
            }
        })
        .catch((err) => console.error("Error fetch data villa:", err));
};

useEffect(() => {
    fetchVillas();
}, []);

// OPEN ADD MODAL
const openAddModal = () => {
    setEditIndex(null);

    setForm({
        id: "",
        name: "",
        location: "",
        mitra_name: "-",
        link_wa: "-",
        price: "",
        rating: "5",
        guests: "4",
        beds: "2",
        baths: "1",
        bed_type: "1 King Size",
        check_in_time: "14:00",
        check_out_time: "12:00",
        status: "available"
    });

    setShowModal(true);
};

// OPEN EDIT MODAL
const openEditModal = (index) => {
    setEditIndex(index);

    const selectedVilla = villas[index];

    setForm({
        id: selectedVilla.id,
        name: selectedVilla.name || "",
        location: selectedVilla.location || "",
        mitra_name: selectedVilla.mitra_name || "-",
        link_wa: selectedVilla.whatsapp || selectedVilla.link_wa || "-",
        price: selectedVilla.price || "",
        rating: selectedVilla.rating || "5",
        guests: selectedVilla.guests || "4",
        beds: selectedVilla.beds || "2",
        baths: selectedVilla.baths || "1",
        bed_type: selectedVilla.bed_type || "1 King Size",
        check_in_time: selectedVilla.check_in_time || "14:00",
        check_out_time: selectedVilla.check_out_time || "12:00",
        status: selectedVilla.status || "available"
    });

    setShowModal(true);
};

// HANDLE INPUT
const handleChange = (e) => {
    setForm({
        ...form,
        [e.target.name]: e.target.value
    });
};

// SAVE DATA
const saveVilla = async () => {
    if (!form.name || !form.location) {
        alert("Mohon isi data wajib");
        return;
    }

    try {
        let response;
        if (editIndex !== null) {
            response = await fetch(
                `http://localhost:5000/api/admin/villas/${form.id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(form)
                }
            );
        } else {
            response = await fetch(
                "http://localhost:5000/api/admin/villas",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(form)
                }
            );
        }

        const dataRes = await response.json();

        if (response.ok) {
            alert(dataRes.message || "Data berhasil disimpan!");
            setShowModal(false);
            fetchVillas();
        } else {
            alert(dataRes.error || "Gagal menyimpan data.");
        }
    } catch (error) {
        console.error("Error saving data:", error);
        alert("Gagal terhubung ke server.");
    }
};

// DELETE
const deleteVilla = async (index) => {
    const selectedVilla = villas[index];

    if (window.confirm(`Apakah Anda yakin ingin menghapus ${selectedVilla.name}?`)) {
        try {
            const response = await fetch(
                `http://localhost:5000/api/admin/villas/${selectedVilla.id}`,
                {
                    method: "DELETE"
                }
            );

            const dataRes = await response.json();

            if (response.ok) {
                alert(dataRes.message || "Villa berhasil dihapus!");
                fetchVillas();
            } else {
                alert(dataRes.error || "Gagal menghapus data.");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            alert("Gagal terhubung ke server.");
        }
    }
};

// TRIGGER BUTTONS
const triggerFileSelect = () => {
    fileInputRef.current.click();
};

const triggerRoomFileSelect = () => {
    roomFileInputRef.current.click();
};

// ==========================================
// FILE 1: IMPORT DATA MITRA (Mitranya.csv)
// ==========================================
const handleCSVUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
        const text = event.target.result;
        const lines = text.split(/\r?\n/);
        let uploadCount = 0;

        for (let i = 1; i < lines.length; i++) {
            const line = lines[i].trim();
            if (!line) continue;

            const columns = line.split(";");
            if (columns.length < 3 || !columns[1] || columns[1].trim() === "") continue;

            const cleanId = columns[0].trim();
            const cleanName = columns[1].trim();
            const cleanLocation = columns[2].trim();
            const cleanWA = columns[3] ? columns[3].trim() : "-";

            const csvData = {
                id: cleanId, // Force ID dari Excel agar sinkron dengan ID relasi di tabel kamar
                name: cleanName,
                location: cleanLocation,
                whatsapp: cleanWA,
                price: 0, 
                rating: "5",
                guests: "0",
                beds: "0",
                baths: "0",
                bed_type: "Hostel/Villa Utama",
                check_in_time: "14:00",
                check_out_time: "12:00",
                status: "available",
                type: "Villa",
                img: "default_mitra.jpg", 
                catalog_link: "",
                promo: "",
                owner_id: cleanId
            };

            try {
                const response = await fetch("http://localhost:5000/api/admin/villas", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(csvData)
                });

                if (response.ok) uploadCount++;
            } catch (err) {
                console.error("Gagal mengimpor mitra di baris ke-" + i, err);
            }
        }

        alert(`Sukses! Berhasil mengimpor ${uploadCount} data Mitra ke Halaman Utama.`);
        e.target.value = "";
        fetchVillas();
    };
    reader.readAsText(file);
};

// ==========================================
// FILE 2: IMPORT DATA KAMAR (Room.csv)
// ==========================================
const handleRoomCSVUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
        const text = event.target.result;
        const lines = text.split(/\r?\n/);
        let uploadCount = 0;

        for (let i = 1; i < lines.length; i++) {
            const line = lines[i].trim();
            if (!line) continue;

            const columns = line.split(";");
            // Validasi nama kamar di kolom indeks ke-2 wajib ada
            if (columns.length < 4 || !columns[2] || columns[2].trim() === "") continue;

            // PEMBERSIH HARGA: Mengatasi range (ex: 650000-950000) dan teks kosong
            let rawPrice = columns[4] ? columns[4].trim() : "0";
            if (rawPrice.includes("-")) {
                rawPrice = rawPrice.split("-")[0].trim();
            }
            let cleanPrice = parseInt(rawPrice.replace(/\D/g, ""), 10);
            if (isNaN(cleanPrice)) {
                cleanPrice = 0;
            }

            const roomData = {
                villa_id: columns[1].trim(), // RELASI: Menghubungkan ke ID Mitra
                room_name: columns[2].trim(),
                room_type: columns[3] ? columns[3].trim() : "Standard Room",
                price: cleanPrice,
                facilities: columns[5] ? columns[5].trim() : "-",
                img: columns[6] ? columns[6].trim() : "default_room.jpg",
                promo: columns[7] ? columns[7].trim() : ""
            };

            try {
                // CATATAN: Pastikan URL endpoint backend ini sudah sesuai dengan route Detail Kamar/Room Anda
                const response = await fetch("http://localhost:5000/api/admin/villa-details", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(roomData)
                });

                if (response.ok) uploadCount++;
            } catch (err) {
                console.error("Gagal mengimpor kamar di baris ke-" + i, err);
            }
        }

        alert(`Sukses! Berhasil mengimpor ${uploadCount} data Kamar/Room ke database detail.`);
        e.target.value = "";
    };
    reader.readAsText(file);
};


return (
<div className="admin-layout">

    {/* SIDEBAR */}
    <div className="sidebar">
        <div>
            <div className="sidebar-logo">
                <div className="logo-icon">🏨</div>
                <div>
                    <h3>Permata Wisata</h3>
                    <span>Portal Admin</span>
                </div>
            </div>

            <div className="menu">
                <Link to="/admin/dashboard" className="menu-item">
                    <FaThLarge /> Dashboard
                </Link>
                <Link to="/admin/villas" className="menu-item active">
                    <FaHome /> Kelola Villa
                </Link>
                <Link to="/admin/transactions" className="menu-item">
                    <FaCalendarAlt /> Transaksi Pemesanan
                </Link>
                <Link to="/admin/payment" className="menu-item">
                    <FaCheckCircle /> Validasi Pembayaran
                </Link>
            </div>
        </div>

        <div className="logout">
            <FaSignOutAlt /> Keluar
        </div>
    </div>

    {/* MAIN */}
    <div className="main">
        <div className="topbar">
            <div>
                <p className="welcome">Selamat datang kembali,</p>
                <h2>Admin</h2>
            </div>

            <div className="top-right">
                <FaBell className="bell"/>
                <div className="admin-profile">
                    <div className="avatar">A</div>
                    <div className="admin-info">
                        <span className="admin-name">Admin</span>
                        <span className="admin-status">Aktif</span>
                    </div>
                </div>
            </div>
        </div>

        {/* HEADER */}
        <div className="page-header">
            <div>
                <h1>Kelola Villa (Mitra Utama)</h1>
                <p>Tambah, edit, dan kelola arsitektur relasi properti penginapan</p>
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
                
                {/* UPLOAD FILE 1 - MITRA */}
                <input
                    type="file"
                    accept=".csv"
                    ref={fileInputRef}
                    onChange={handleCSVUpload}
                    style={{ display: "none" }}
                />
                <button
                    className="import-csv-btn"
                    onClick={triggerFileSelect}
                    style={{
                        backgroundColor: "#27ae60",
                        color: "white",
                        border: "none",
                        padding: "10px 15px",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer"
                    }}
                >
                    <FaFileCsv />
                    Import CSV Mitra
                </button>

                {/* UPLOAD FILE 2 - ROOM */}
                <input
                    type="file"
                    accept=".csv"
                    ref={roomFileInputRef}
                    onChange={handleRoomCSVUpload}
                    style={{ display: "none" }}
                />
                <button
                    className="import-csv-btn"
                    onClick={triggerRoomFileSelect}
                    style={{
                        backgroundColor: "#2980b9",
                        color: "white",
                        border: "none",
                        padding: "10px 15px",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer"
                    }}
                >
                    <FaFileCsv />
                    Import CSV Room
                </button>

                <button className="add-btn" onClick={openAddModal}>
                    <FaPlus /> Tambah Villa
                </button>
            </div>
        </div>

        {/* TABLE */}
        <div className="villa-table">
            <table>
                <thead>
                    <tr>
                        <th>ID Mitra</th>
                        <th>Nama Mitra Penginapan</th>
                        <th>Alamat / Lokasi</th>
                        <th>Link WhatsApp Resmi</th>
                        <th>Status</th>
                        <th>Aksi</th>
                    </tr>
                </thead>

                <tbody>
                    {villas.length > 0 ? (
                        villas.map((villa, index) => (
                            <tr key={villa.id || index}>
                                <td>{villa.id}</td>
                                <td><strong>{villa.name}</strong></td>
                                <td>{villa.location}</td>
                                <td>
                                    {villa.whatsapp && villa.whatsapp !== "-" ? (
                                        <a
                                            href={villa.whatsapp.startsWith("http") ? villa.whatsapp : `https://wa.me/${villa.whatsapp}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ color: "#27ae60", fontWeight: "600" }}
                                        >
                                            Hubungi WA Mitra
                                        </a>
                                    ) : (
                                        "-"
                                    )}
                                </td>
                                <td>
                                    <span className={`status ${villa.status || 'available'}`}>
                                        {villa.status || 'available'}
                                    </span>
                                </td>
                                <td className="actions">
                                    <FaEdit className="edit" onClick={() => openEditModal(index)} />
                                    <FaTrash className="delete" onClick={() => deleteVilla(index)} />
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="6" style={{ textAlign: "center" }}>
                                Belum ada data Mitra. Silakan klik tombol "Import CSV Mitra" terlebih dahulu.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    </div>
</div>
);
}

export default AdminManageVillas;